"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@engaging-tech/components");
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var _AnimatedStarIcon = _interopRequireDefault(require("./AnimatedStarIcon"));
var NavUserDetails = function NavUserDetails() {
  var _userDetails$details, _userDetails$details2, _userDetails$details3, _userDetails$details4, _userDetails$details5, _userDetails$details6, _userDetails$details7, _userDetails$details8;
  var _useNavContext = (0, _useNavContext2["default"])(),
    userDetails = _useNavContext.userDetails,
    holdingImage = _useNavContext.holdingImage;
  var name = ((userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$details = userDetails.details) === null || _userDetails$details === void 0 ? void 0 : _userDetails$details.firstName) || "") + " " + ((userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$details2 = userDetails.details) === null || _userDetails$details2 === void 0 ? void 0 : _userDetails$details2.lastName) || "");
  var handleOnClick = function handleOnClick() {
    userDetails === null || userDetails === void 0 ? void 0 : userDetails.onClick();
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, userDetails && userDetails.isAuthenticated && /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    width: "auto",
    alignItems: "center",
    flexDirection: "row",
    onClick: handleOnClick,
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    alignItems: "center",
    bg: userDetails !== null && userDetails !== void 0 && (_userDetails$details3 = userDetails.details) !== null && _userDetails$details3 !== void 0 && (_userDetails$details4 = _userDetails$details3.premium) !== null && _userDetails$details4 !== void 0 && _userDetails$details4.active ? (userDetails === null || userDetails === void 0 ? void 0 : userDetails.premiumColor) || "primary.1" : (userDetails === null || userDetails === void 0 ? void 0 : userDetails.nonPremiumColor) || "dark.2",
    borderRadius: 99,
    height: 34,
    py: 1,
    px: 2,
    mr: 3
  }, (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$details5 = userDetails.details) === null || _userDetails$details5 === void 0 ? void 0 : (_userDetails$details6 = _userDetails$details5.premium) === null || _userDetails$details6 === void 0 ? void 0 : _userDetails$details6.active) && /*#__PURE__*/_react["default"].createElement(_AnimatedStarIcon["default"], {
    color: "dark.3"
  }), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    color: "dark.1",
    fontSize: 3,
    mx: 2
  }, name), /*#__PURE__*/_react["default"].createElement(_components.Avatar, {
    picture: (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$details7 = userDetails.details) === null || _userDetails$details7 === void 0 ? void 0 : (_userDetails$details8 = _userDetails$details7.picture) === null || _userDetails$details8 === void 0 ? void 0 : _userDetails$details8.small) || holdingImage || null,
    size: 24,
    ml: 1
  }))));
};
var _default = exports["default"] = NavUserDetails;